import { render, staticRenderFns } from "./M_logCleaningSettings.vue?vue&type=template&id=48b8da04&scoped=true&"
import script from "./M_logCleaningSettings.vue?vue&type=script&lang=js&"
export * from "./M_logCleaningSettings.vue?vue&type=script&lang=js&"
import style0 from "./M_logCleaningSettings.vue?vue&type=style&index=0&id=48b8da04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8da04",
  null
  
)

export default component.exports